import React from 'react';


const ScorerItem = (props) => {


    const { item, team } = props;

    // const playerLogo = (item && item.logoUrl) ? item.logoUrl : process.env.PUBLIC_URL + "/player_logo.png"
    const playerLogo = (item && item.logoUrl) ?
        item.logoUrl
        :
        item.position !== "Director Técnico" ?
            process.env.PUBLIC_URL + "/shirt.png"
            :
            process.env.PUBLIC_URL + "/player_logo.png"

    const goals = (item.statistic && item.statistic.goals) || 0;

    return (
        <tr className="bg-hover-td">
            <td className="align-middle text-right pl-1 pr-1"  >
                <div className="d-flex justify-content-center align-items-center" style={{
                    backgroundImage: `url(${playerLogo})`,
                    height: 30,
                    width: 32,
                    minWidth: 30,
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat'
                }} >
                    <span className="font-weight-bold" style={{ fontSize: 12 }}>
                        {item.position !== "Director Técnico" && (item.number || '-')}
                    </span>
                </div>
            </td>
            <td className="align-middle " >
                <div>
                    <span className="font-weight-bold d-block">{item.name}</span>
                    <span className="text-secondary">{team.title}</span>
                </div>
            </td>

            <td className="align-middle text-center"  >{goals}</td>

        </tr>
    )


}

export default ScorerItem;
